import { render } from "./PuntoCyan.vue?vue&type=template&id=f58a402c&scoped=true"
import script from "./PuntoCyan.vue?vue&type=script&lang=ts"
export * from "./PuntoCyan.vue?vue&type=script&lang=ts"

import "./PuntoCyan.vue?vue&type=style&index=0&id=f58a402c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f58a402c"

export default script